export default class CssUtils {
  static getComputedPropertyStyleValue = (element, styleProperty) => {
    if (!element || !styleProperty) return undefined;

    var computedStyle = getComputedStyle(element);

    var computedStylePropertyValue =
      computedStyle?.getPropertyValue(styleProperty);

    return computedStylePropertyValue;
  };

  static getQuerySelectorComputedStyle = (selector, styleProperty) => {
    if (!styleProperty) return undefined;

    const element = document?.querySelector(selector);
    if (!element) return undefined;

    return CssUtils.getComputedPropertyStyleValue(element, styleProperty);
  };

  static getRootComputedStyle = styleProperty => {
    if (!styleProperty || !document?.documentElement) return undefined;

    return CssUtils.getComputedPropertyStyleValue(
      document.documentElement,
      styleProperty
    );
  };
}
